import { type Control, useFormContext, useWatch } from "react-hook-form";
import { useResourceFormContext as useFormFrameworkContext } from "src/components/Form/hooks/useResourceFormContext.ts";

import {
  getHiddenFieldConfig,
  getNamesToWatchForHiddenFields,
} from "src/components/Form/utils/hiddenFields.ts";

export const useIsFieldHidden = ({
  name,
  control: controlProp,
}: {
  name: string;
  control?: Control<any>;
}) => {
  const { control: controlFromContext, getValues } = useFormContext<any>();
  const { hidden_fields, fields } = useFormFrameworkContext();

  const control = controlProp ?? controlFromContext;

  const namesToWatch = getNamesToWatchForHiddenFields({
    getValues,
    hidden_fields,
    fields,
    names: [name],
  });

  const hiddenField = getHiddenFieldConfig({
    name,
    hidden_fields,
    fields,
  });

  useWatch({
    // @ts-ignore
    name: namesToWatch,
    disabled: !hiddenField,
    control,
  });

  const isHidden = hiddenField
    ? typeof hiddenField === "function"
      ? hiddenField(getValues())
      : hiddenField.hide_condition(getValues())
    : false;

  return {
    isHidden,
  };
};
